var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step-subcription-root" },
    [
      _c("h1", [
        _vm._v(
          _vm._s(_vm.$l10n.__("Abonnement de")) +
            " " +
            _vm._s(_vm.customer.name)
        )
      ]),
      _vm._v(" "),
      _vm.isCartLoaded
        ? _c(
            "div",
            [
              _vm.savedCartStatus == "draft"
                ? _c("el-alert", {
                    attrs: {
                      title: _vm.$t.__(
                        "sellsyaccountmanager.subscriptionform.SubscriptionSale.cart_edited_in_draft_by_sale"
                      ),
                      closable: false,
                      type: "error"
                    }
                  })
                : _c("el-alert", {
                    attrs: {
                      title: _vm.$t.__(
                        "sellsyaccountmanager.subscriptionform.SubscriptionSale.active_cart_already_exist"
                      ),
                      closable: false,
                      type: "error"
                    }
                  })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 40 } },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c(
              "div",
              { staticClass: "mb-4" },
              [
                _c("h4", [
                  _vm._v(_vm._s(_vm._f("capitalize")(_vm.$l10n.__("contact"))))
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "billingContactForm",
                    staticClass: "well pb-0",
                    attrs: {
                      model: _vm.billingContactTmp,
                      "label-position": "top",
                      "inline-message": true,
                      rules: _vm.samBillingContactRules
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t.__("common.labels.first_name"),
                          prop: "contactFirstName",
                          error: _vm.errors.get("contactFirstName")
                        }
                      },
                      [
                        _c("text-input", {
                          attrs: { mode: "edit" },
                          model: {
                            value: _vm.billingContactTmp.contactFirstName,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.billingContactTmp,
                                "contactFirstName",
                                $$v
                              )
                            },
                            expression: "billingContactTmp.contactFirstName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t.__("common.labels.name"),
                          prop: "contactName",
                          error: _vm.errors.get("contactName")
                        }
                      },
                      [
                        _c("text-input", {
                          attrs: { mode: "edit" },
                          model: {
                            value: _vm.billingContactTmp.contactName,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.billingContactTmp,
                                "contactName",
                                $$v
                              )
                            },
                            expression: "billingContactTmp.contactName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t.__("common.labels.email_address"),
                          prop: "contactEmail",
                          error: _vm.errors.get("contactEmail")
                        }
                      },
                      [
                        _c("text-input", {
                          attrs: { type: "email", mode: "edit" },
                          model: {
                            value: _vm.billingContactTmp.contactEmail,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.billingContactTmp,
                                "contactEmail",
                                $$v
                              )
                            },
                            expression: "billingContactTmp.contactEmail"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t.__("common.labels.phone"),
                          prop: "contactPhone",
                          error: _vm.errors.get("contactPhone")
                        }
                      },
                      [
                        _c("tel-input", {
                          attrs: { mode: "edit" },
                          on: { change: _vm.updateBilligContactPhoneTmp },
                          model: {
                            value: _vm.billingContactPhoneTmp,
                            callback: function($$v) {
                              _vm.billingContactPhoneTmp = $$v
                            },
                            expression: "billingContactPhoneTmp"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t.__("common.labels.invoicing_language"),
                          prop: "locale",
                          error: _vm.errors.get("locale")
                        }
                      },
                      [
                        _c("select-input", {
                          staticClass: "m-0",
                          attrs: {
                            mode: "edit",
                            options: _vm.billingLocales,
                            "label-column": "name",
                            "id-column": "code",
                            filterable: true
                          },
                          model: {
                            value: _vm.billingContactTmp.locale,
                            callback: function($$v) {
                              _vm.$set(_vm.billingContactTmp, "locale", $$v)
                            },
                            expression: "billingContactTmp.locale"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          rules: _vm.additionalEmailRecipientsRules,
                          label: _vm.$t.__(
                            "common.labels.offer_recipient_emails"
                          ),
                          prop: "additionalEmailRecipients",
                          error: _vm.errors.get("additionalEmailRecipients")
                        }
                      },
                      [
                        _c("el-select", {
                          staticClass: "wp-10 no-caret",
                          attrs: {
                            multiple: "",
                            filterable: "",
                            "default-first-option": "",
                            "allow-create": "",
                            "collapse-tags": false,
                            "popper-class": "hidden",
                            placeholder: _vm.$t.__(
                              "common.actions.search_email"
                            )
                          },
                          model: {
                            value:
                              _vm.billingContactTmp.additionalEmailRecipients,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.billingContactTmp,
                                "additionalEmailRecipients",
                                $$v
                              )
                            },
                            expression:
                              "billingContactTmp.additionalEmailRecipients"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-4" },
              [
                _c("h4", [
                  _vm._v(
                    _vm._s(
                      _vm._f("capitalize")(
                        _vm.$l10n.__("adresse de facturation du client")
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "billingAddressForm",
                    staticClass: "well pb-0",
                    attrs: {
                      model: _vm.billingAddressTmp,
                      "label-position": "top",
                      "inline-message": true,
                      rules: _vm.samBillingAddressAndIntraVatRules
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t.__("common.labels.street_name"),
                          prop: "line1",
                          error: _vm.errors.get("line1")
                        }
                      },
                      [
                        _c("algolia-places", {
                          attrs: {
                            "default-value": _vm.billingAddressTmp.line1,
                            templates: {
                              value: function(suggestion) {
                                return suggestion.name
                              }
                            }
                          },
                          on: { "bubble-address": _vm.captureAddress }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t.__(
                            "common.labels.more_address_informations"
                          ),
                          prop: "line2",
                          error: _vm.errors.get("line2")
                        }
                      },
                      [
                        _c("text-input", {
                          attrs: { mode: "edit" },
                          model: {
                            value: _vm.billingAddressTmp.line2,
                            callback: function($$v) {
                              _vm.$set(_vm.billingAddressTmp, "line2", $$v)
                            },
                            expression: "billingAddressTmp.line2"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-level" }, [
                      _c(
                        "div",
                        { staticClass: "flex pr-2" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t.__("common.labels.postal_code"),
                                prop: "postalCode",
                                error: _vm.errors.get("postalCode")
                              }
                            },
                            [
                              _c("text-input", {
                                attrs: { mode: "edit" },
                                model: {
                                  value: _vm.billingAddressTmp.postalCode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.billingAddressTmp,
                                      "postalCode",
                                      $$v
                                    )
                                  },
                                  expression: "billingAddressTmp.postalCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex-3 pl-2" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t.__("common.labels.city"),
                                prop: "city",
                                error: _vm.errors.get("city")
                              }
                            },
                            [
                              _c("text-input", {
                                attrs: { mode: "edit" },
                                model: {
                                  value: _vm.billingAddressTmp.city,
                                  callback: function($$v) {
                                    _vm.$set(_vm.billingAddressTmp, "city", $$v)
                                  },
                                  expression: "billingAddressTmp.city"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-level" }, [
                      _c(
                        "div",
                        { staticClass: "flex pr-2" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t.__("common.labels.state"),
                                prop: "state",
                                error: _vm.errors.get("state")
                              }
                            },
                            [
                              _c("text-input", {
                                staticClass: "m-0",
                                attrs: { mode: "edit" },
                                model: {
                                  value: _vm.billingAddressTmp.state,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.billingAddressTmp,
                                      "state",
                                      $$v
                                    )
                                  },
                                  expression: "billingAddressTmp.state"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex pl-2" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t.__("common.labels.country"),
                                prop: "country",
                                error: _vm.errors.get("country")
                              }
                            },
                            [
                              _c("select-input", {
                                staticClass: "m-0",
                                attrs: {
                                  mode: "edit",
                                  options: _vm.countries,
                                  "label-column": "name",
                                  "id-column": "code",
                                  filterable: true
                                },
                                model: {
                                  value: _vm.billingAddressTmp.country,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.billingAddressTmp,
                                      "country",
                                      $$v
                                    )
                                  },
                                  expression: "billingAddressTmp.country"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.showTaxTotalInForm
                      ? _c(
                          "div",
                          { staticClass: "mt-4 container-tiny m-auto" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t.__("common.labels.tax_number"),
                                  prop: "vatIdentificationNumber",
                                  error: _vm.errors.get(
                                    "vatIdentificationNumber"
                                  )
                                }
                              },
                              [
                                _c("text-input", {
                                  attrs: { mode: "edit" },
                                  model: {
                                    value:
                                      _vm.billingAddressTmp
                                        .vatIdentificationNumber,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.billingAddressTmp,
                                        "vatIdentificationNumber",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "billingAddressTmp.vatIdentificationNumber"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-4" },
              [
                _c("h4", [
                  _vm._v(_vm._s(_vm.$l10n.__("Personnalisation des emails")))
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "billingCustomMail",
                    staticClass: "well pb-0",
                    attrs: {
                      model: _vm.billingCustomMail,
                      "label-position": "top",
                      "inline-message": true,
                      rules: _vm.samBillingCustomMailRules
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticClass: "semibold" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("Message personnalisé")))
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-checkbox",
                          {
                            on: { change: _vm.handleCustomMail },
                            model: {
                              value: _vm.activeCustomMail,
                              callback: function($$v) {
                                _vm.activeCustomMail = $$v
                              },
                              expression: "activeCustomMail"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$l10n.__(
                                  "Joindre mon message personnalisé dans l’email envoyé"
                                )
                              )
                            )
                          ]
                        )
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.activeCustomMail
                      ? _c(
                          "el-form-item",
                          [
                            _c("RichText", {
                              staticClass: "custom-richtext",
                              attrs: {
                                placeholder: _vm.$t.__(
                                  "common.actions.enter_custom_message"
                                ),
                                options: _vm.optionsRichText
                              },
                              model: {
                                value: _vm.billingCustomMail.message,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.billingCustomMail,
                                    "message",
                                    $$v
                                  )
                                },
                                expression: "billingCustomMail.message"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticClass: "semibold" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("Infos de contact")))
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.billingCustomMail.contactAdded,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.billingCustomMail,
                                  "contactAdded",
                                  $$v
                                )
                              },
                              expression: "billingCustomMail.contactAdded"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$l10n.__(
                                  "Ajouter mes informations de contact"
                                )
                              )
                            )
                          ]
                        )
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.billingCustomMail.contactAdded
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__(
                                "sellsyaccountmanager.subscriptionform.SubscriptionSale.name_lastname"
                              ),
                              prop: "contactName"
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.billingCustomMail.contactName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.billingCustomMail,
                                    "contactName",
                                    $$v
                                  )
                                },
                                expression: "billingCustomMail.contactName"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.billingCustomMail.contactAdded
                      ? _c(
                          "div",
                          { staticClass: "flex-row" },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "wp-5",
                                attrs: {
                                  label: _vm.$t.__("common.labels.email"),
                                  prop: "contactMailAddress"
                                }
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value:
                                      _vm.billingCustomMail.contactMailAddress,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.billingCustomMail,
                                        "contactMailAddress",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "billingCustomMail.contactMailAddress"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "wp-5 ml-3",
                                attrs: {
                                  label: _vm.$t.__(
                                    "sellsyaccountmanager.subscriptionform.SubscriptionSale.phone_number"
                                  ),
                                  prop: "contactPhone"
                                }
                              },
                              [
                                _c("tel-input", {
                                  on: {
                                    change: _vm.updateCustomMailContactPhone
                                  },
                                  model: {
                                    value: _vm.billingCustomMailContactPhone,
                                    callback: function($$v) {
                                      _vm.billingCustomMailContactPhone = $$v
                                    },
                                    expression: "billingCustomMailContactPhone"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("h4", [_vm._v(_vm._s(_vm.$l10n.__("Configuration compte")))]),
              _vm._v(" "),
              _c("div", { staticClass: "well py-1" }, [
                _c(
                  "div",
                  { staticClass: "h-5 flex-level" },
                  [
                    _c("span", { staticClass: "flex" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("Expiration de l'offre")))
                    ]),
                    _vm._v(" "),
                    _c("date-input", {
                      staticClass: "w-2",
                      attrs: {
                        mode: "edit",
                        "can-be-in-the-past": false,
                        placeholder: _vm.$t.__("common.labels.expire_date")
                      },
                      on: { input: _vm.expirationDateUpdated },
                      model: {
                        value: _vm.expireDate,
                        callback: function($$v) {
                          _vm.expireDate = $$v
                        },
                        expression: "expireDate"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "h-5 flex-level bt-1" },
                  [
                    _c("span", { staticClass: "flex" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("Contexte")))
                    ]),
                    _vm._v(" "),
                    _c("select-input", {
                      staticClass: "w-2 aright flex-right",
                      attrs: {
                        mode: "edit",
                        value: _vm.cartContext,
                        placeholder: _vm.$t.__(
                          "sellsyaccountmanager.subscriptionform.SubscriptionSale.select_context"
                        ),
                        options: _vm.saleContexts,
                        "label-column": "label",
                        "id-column": "value"
                      },
                      on: { input: _vm.contextUpdated }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.isCartContext("upsale")
                  ? _c(
                      "div",
                      { staticClass: "h-5 flex-level bt-1" },
                      [
                        _vm.isCartContext("new")
                          ? _c("span", { staticClass: "flex" }, [
                              _vm._v(_vm._s(_vm.$l10n.__("Date d'activation")))
                            ])
                          : _c("span", { staticClass: "flex" }, [
                              _vm._v(
                                _vm._s(_vm.$l10n.__("Date de renouvellement"))
                              )
                            ]),
                        _vm._v(" "),
                        _vm.isCartContext("new")
                          ? _c("span", { staticClass: "mx-2" }, [
                              _vm._v(_vm._s(_vm.$l10n.__("à partir du")))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("date-input", {
                          attrs: {
                            mode: "edit",
                            "can-be-in-the-past": false,
                            placeholder: _vm.$t.__("common.labels.start_date"),
                            disabled: !_vm.isCartContext("new")
                          },
                          on: { input: _vm.periodApplianceStartUpdated },
                          model: {
                            value: _vm.startDate,
                            callback: function($$v) {
                              _vm.startDate = $$v
                            },
                            expression: "startDate"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canEarlyRenew
                  ? _c("div", { staticClass: "h-5 flex-level bt-1" }, [
                      _c("span", { staticClass: "flex" }, [
                        _vm._v(_vm._s(_vm.$l10n.__("Renouvellement anticipé")))
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: { checked: _vm.cartEarlyRenewal },
                        on: { change: _vm.setEarly }
                      })
                    ])
                  : _vm.cartEarlyRenewal
                  ? _c("div", { staticClass: "h-5 flex-level bt-1" }, [
                      _c("span", { staticClass: "flex" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$l10n.__("Renouvellement anticipé")))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isCartContext("new") && _vm.customerServiceStartDate
                  ? _c("div", { staticClass: "h-5 flex-level bt-1" }, [
                      _c("span", { staticClass: "flex" }, [
                        _vm._v(_vm._s(_vm.$l10n.__("Actuellement engagé")))
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$l10n.__("du %(start)s au %(end)s", {
                              start: _vm.$options.filters.dateFormatter(
                                _vm.customerServiceStartDateObj.unix(),
                                "NORMAL_DATE",
                                false
                              ),
                              end: _vm.$options.filters.dateFormatter(
                                _vm.customerServiceEndDateObj.unix(),
                                "NORMAL_DATE",
                                false
                              )
                            })
                          )
                        )
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("h4", [_vm._v(_vm._s(_vm.$l10n.__("Panier Client")))]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "subscriptionForm",
                  staticClass: "well",
                  attrs: {
                    "label-position": "top",
                    "inline-message": true,
                    model: _vm.subscription
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "pb-3 m-0 bb-1",
                      attrs: {
                        prop: "pricingPlan",
                        error: _vm.errors.get("pricingPlan")
                      }
                    },
                    [
                      _c("h4", { staticClass: "mt-2 dinlineb" }, [
                        _vm._v(_vm._s(_vm.$l10n.__("Type de paiement")))
                      ]),
                      _vm._v(" "),
                      _c("radio-input", {
                        staticClass: "dinlineb fright",
                        attrs: {
                          mode: "edit",
                          "radio-style": "button",
                          value: _vm.currentPricingPlan,
                          choices: _vm.pricingPlansChoices,
                          disabled: _vm.isCartContext("upsale")
                        },
                        on: {
                          change: function($event) {
                            ;[
                              _vm.switchAllStepsPricing($event),
                              _vm.switchCartItemPricing($event),
                              _vm.switchPricingPlan($event)
                            ]
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.cartBasicProduct
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "bb-1 pb-3 mb-1",
                          attrs: {
                            prop: "nbLicences",
                            error: _vm.errors.get("nbLicences"),
                            rules: _vm.minLicenceValidator
                          }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("h4", [
                                _vm._v(
                                  _vm._s(_vm.$l10n.__("Utilisateurs et Outils"))
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.userPricingSteps, function(
                                pricingStep,
                                index
                              ) {
                                return [
                                  index !== 0
                                    ? _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass:
                                            "flex-level ai-center mt-1 pricing-step"
                                        },
                                        [
                                          index ===
                                            _vm.userPricingSteps.length - 1 &&
                                          _vm.userPricingSteps.length > 2
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$l10n.n__(
                                                      "À partir de %s utilisateur",
                                                      "À partir de %s utilisateurs",
                                                      _vm.userPricingSteps[
                                                        index - 1
                                                      ].up_to + 1,
                                                      _vm.userPricingSteps[
                                                        index - 1
                                                      ].up_to + 1
                                                    )
                                                  )
                                                )
                                              ])
                                            : index !==
                                              _vm.userPricingSteps.length - 1
                                            ? [
                                                _c(
                                                  "div",
                                                  { staticClass: "flex-level" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$l10n.n__(
                                                            "De %(base)s à %(upto)s utilisateur",
                                                            "De %(base)s à %(upto)s utilisateurs",
                                                            pricingStep.nbLicences,
                                                            {
                                                              base:
                                                                _vm
                                                                  .userPricingSteps[
                                                                  index - 1
                                                                ].up_to + 1,
                                                              upto:
                                                                pricingStep.nbLicences ===
                                                                0
                                                                  ? _vm
                                                                      .userPricingSteps[
                                                                      index - 1
                                                                    ].up_to + 1
                                                                  : pricingStep.up_to
                                                            }
                                                          )
                                                        ) +
                                                          "\n                                        "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            : [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$l10n.__(
                                                        "Utilisateurs"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ],
                                          _vm._v(" "),
                                          _c("el-input-number", {
                                            staticClass:
                                              "w-100 mx-2 flex-item-right",
                                            attrs: {
                                              value: pricingStep.nbLicences,
                                              min: _vm.getMininalLicence(
                                                pricingStep.nbLicences,
                                                1
                                              ),
                                              "controls-position": "right"
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.updateLicences(
                                                  $event,
                                                  index
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.getProductPlan(
                                            _vm.pricingBasicProduct,
                                            _vm.currentPricingPlan
                                          ).isCustomPricingAmountInCentsEnabled
                                            ? _c("select-input", {
                                                staticClass:
                                                  "mx-2 dinlineb amount-month-price-select",
                                                attrs: {
                                                  mode: "edit",
                                                  options: _vm.getCustomPricingAmountForProduct(
                                                    _vm.pricingBasicProduct,
                                                    _vm.currentPricingPlan
                                                  ),
                                                  "label-column": "label",
                                                  "id-column": "value"
                                                },
                                                on: {
                                                  input: _vm.updatePricingStep
                                                },
                                                model: {
                                                  value:
                                                    pricingStep.unit_amount,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      pricingStep,
                                                      "unit_amount",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "pricingStep.unit_amount"
                                                }
                                              })
                                            : _c(
                                                "span",
                                                { staticClass: "mx-1" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatAmount(
                                                        _vm.currentPricingPlan ===
                                                          "MONTHLY"
                                                          ? _vm.cartBasicProduct
                                                              .customPricing
                                                          : _vm.cartBasicProduct
                                                              .customPricing /
                                                              12,
                                                        false,
                                                        true
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.currencySymbol) +
                                                " / " +
                                                _vm._s(_vm.$l10n.__("mois")) +
                                                " /\n                                    " +
                                                _vm._s(_vm.$l10n.__("unité")) +
                                                "."
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.userPricingSteps.length > 2
                                            ? _c(
                                                "el-button",
                                                {
                                                  staticClass:
                                                    "red delete-pricing-step pl-4 pr-2",
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.deletePricingStep(
                                                        index
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "icon-less"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ]
                              }),
                              _vm._v(" "),
                              _c("CompassButton", {
                                staticClass: "mt-2",
                                attrs: {
                                  label: _vm.$t.__("common.actions.add_step"),
                                  type: "primary"
                                },
                                on: { click: _vm.addPricingStep }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-level flex-right flex mt-4 ai-center"
                                },
                                [
                                  _c("span", { staticClass: "mr-2" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$l10n.n__(
                                            "Utilisateur offert",
                                            "Utilisateurs offerts",
                                            _vm.userPricingSteps[0].up_to
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("el-input-number", {
                                    staticClass: "w-80",
                                    attrs: {
                                      "controls-position": "right",
                                      min: _vm.getMininalLicence(
                                        _vm.userPricingSteps[0].nbLicences,
                                        0
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.updateLicences($event, 0)
                                      }
                                    },
                                    model: {
                                      value: _vm.userPricingSteps[0].nbLicences,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.userPricingSteps[0],
                                          "nbLicences",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "userPricingSteps[0].nbLicences"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "flex flex-right flex-level mt-2"
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Total du nombre d'utilisateurs"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                  _c("el-input-number", {
                                    staticClass: "total-user w-80 ml-2",
                                    attrs: {
                                      value: _vm.totalNbLicences,
                                      disabled: "",
                                      controls: false
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "m-0 product-list" },
                    [
                      _c("li", { staticClass: "bb-1 py-3 flex-level h-5" }, [
                        _c("h3", { staticClass: "w-3 m-0" }, [
                          _vm._v(_vm._s(_vm.pricingBasicProduct.printableName))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "flex-2 aright m-0" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm._f("capitalize")(_vm.$l10n.__("inclus"))
                              ) +
                              "\n                        "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.pricingOptionalProducts, function(
                        product,
                        index
                      ) {
                        return _c(
                          "li",
                          {
                            key: product.code,
                            staticClass: "bb-1 py-3 flex-level h-5"
                          },
                          [
                            _c(
                              "h3",
                              { staticClass: "m-0 product-line-title" },
                              [_vm._v(_vm._s(product.printableName))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex product-line-basic-price" },
                              [
                                _vm.getProductMonthlyAmount(
                                  product,
                                  _vm.currentPricingPlan
                                ) !==
                                _vm.getProductMonthlyAmount(
                                  product,
                                  _vm.currentPricingPlan,
                                  false
                                )
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "block gray-60 fs-3 regular"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm._f("capitalize")(
                                                _vm.$l10n.__(
                                                  "tarif de base: %(amount_f)s/mois",
                                                  {
                                                    amount_f: _vm.formatAmount(
                                                      _vm.getPricingByPlan(
                                                        _vm.getProductMonthlyAmount(
                                                          product,
                                                          _vm.currentPricingPlan,
                                                          false
                                                        )
                                                      )
                                                    )
                                                  }
                                                )
                                              )
                                            ) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-level aright product-line-price"
                              },
                              [
                                _vm.getProductPlan(
                                  product,
                                  _vm.currentPricingPlan
                                ).isCustomPricingAmountInCentsEnabled
                                  ? _c("select-input", {
                                      attrs: {
                                        mode: "edit",
                                        value: _vm.getProductMonthlyAmount(
                                          product,
                                          _vm.currentPricingPlan
                                        ),
                                        options: _vm.getCustomPricingAmountForProduct(
                                          product,
                                          _vm.currentPricingPlan
                                        ),
                                        "label-column": "label",
                                        "id-column": "value",
                                        disabled:
                                          _vm.isProductSubscribedByCustomer(
                                            product.code
                                          ) ||
                                          !_vm.getCartItem(product.id) ||
                                          _vm.offersProducts.includes(index)
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.updateCartItemCustomPricing(
                                            product.id,
                                            $event
                                          )
                                        }
                                      }
                                    })
                                  : _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm.getProductMonthlyAmount(
                                              product,
                                              _vm.currentPricingPlan
                                            ),
                                            false,
                                            true
                                          )
                                        )
                                      )
                                    ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "ml-1 gray-60 fs-3 regular" },
                                  [
                                    _vm._v(
                                      "\n                                / " +
                                        _vm._s(
                                          _vm._f("capitalize")(
                                            _vm.$l10n.__("mois")
                                          )
                                        )
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-level ml-4" },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    ref: "offer",
                                    refInFor: true,
                                    attrs: {
                                      checked:
                                        _vm.getProductMonthlyAmount(
                                          product,
                                          _vm.currentPricingPlan
                                        ) === 0,
                                      disabled: !_vm.canProductBeToggled(
                                        product,
                                        false
                                      )
                                    },
                                    on: {
                                      change: function(e) {
                                        return _vm.offerProduct(
                                          product,
                                          index,
                                          e
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$l10n.__("Offert")))]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ml-4 flex-level aright" },
                              [
                                _c("el-switch", {
                                  attrs: {
                                    value: !!_vm.getCartItem(product.id),
                                    disabled: !_vm.canProductBeToggled(
                                      product,
                                      false
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.toggleItem(product)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.pricingOptionalProductsGroups, function(
                        group,
                        index
                      ) {
                        return _c(
                          "li",
                          { key: group, staticClass: "bb-1 py-3" },
                          [
                            _c(
                              "h3",
                              { staticClass: "m-0 product-line-title" },
                              [_vm._v(_vm._s(_vm._f("capitalize")(group)))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-level" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex-level flex" },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "w-80 flex-level" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "fs-3 gray-80 dinlineb",
                                            attrs: {
                                              href:
                                                "https://rocketchart.co/pricing/",
                                              target: "_blank",
                                              title: _vm.$t.__(
                                                "sellsyaccountmanager.subscriptionform.SubscriptionSale.rocketchart_plan"
                                              )
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "icon-help"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "ml-1" }, [
                                          _vm._v(_vm._s(_vm.$l10n.__("Plan")))
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "ml-2 mr-3",
                                        attrs: {
                                          disabled:
                                            _vm.isProductSubscribedByCustomer(
                                              _vm.getGroupedProductByCode(
                                                _vm.optionalGroupOptions[index]
                                                  .plan
                                              ).code
                                            ) ||
                                            !_vm.getCartItem(
                                              _vm.getGroupedProductByCode(
                                                _vm.optionalGroupOptions[index]
                                                  .plan
                                              ).id
                                            ) ||
                                            _vm.offersProducts.includes(index)
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.toggleItem(
                                              _vm.getGroupedProductByCode(
                                                _vm.optionalGroupOptions[index]
                                                  .plan
                                              )
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.optionalGroupOptions[index]
                                              .plan,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.optionalGroupOptions[index],
                                              "plan",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "optionalGroupOptions[index].plan"
                                        }
                                      },
                                      _vm._l(
                                        _vm.getProductsGroupable(group),
                                        function(product) {
                                          return _c("el-option", {
                                            key: product.id,
                                            attrs: {
                                              value: product.code,
                                              label: product.printableName
                                                .split("-")[1]
                                                .trim()
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.optionalGroupOptions[index].plan
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-level aright product-line-price"
                                        },
                                        [
                                          _vm.getProductPlan(
                                            _vm.getGroupedProductByCode(
                                              _vm.optionalGroupOptions[index]
                                                .plan
                                            ),
                                            _vm.currentPricingPlan
                                          ).isCustomPricingAmountInCentsEnabled
                                            ? _c("select-input", {
                                                attrs: {
                                                  mode: "edit",
                                                  value: _vm.getProductMonthlyAmount(
                                                    _vm.getGroupedProductByCode(
                                                      _vm.optionalGroupOptions[
                                                        index
                                                      ].plan
                                                    ),
                                                    _vm.currentPricingPlan
                                                  ),
                                                  options: _vm.getCustomPricingAmountForProduct(
                                                    _vm.getGroupedProductByCode(
                                                      _vm.optionalGroupOptions[
                                                        index
                                                      ].plan
                                                    ),
                                                    _vm.currentPricingPlan
                                                  ),
                                                  "label-column": "label",
                                                  "id-column": "value",
                                                  disabled:
                                                    _vm.isProductSubscribedByCustomer(
                                                      _vm.getGroupedProductByCode(
                                                        _vm
                                                          .optionalGroupOptions[
                                                          index
                                                        ].plan
                                                      ).code
                                                    ) ||
                                                    !_vm.getCartItem(
                                                      _vm.getGroupedProductByCode(
                                                        _vm
                                                          .optionalGroupOptions[
                                                          index
                                                        ].plan
                                                      ).id
                                                    ) ||
                                                    _vm.offersProducts.includes(
                                                      index
                                                    )
                                                },
                                                on: {
                                                  input: function($event) {
                                                    _vm.updateCartItemCustomPricing(
                                                      _vm.getGroupedProductByCode(
                                                        _vm
                                                          .optionalGroupOptions[
                                                          index
                                                        ].plan
                                                      ).id,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            : _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatAmount(
                                                      _vm.getProductMonthlyAmount(
                                                        _vm.getGroupedProductByCode(
                                                          _vm
                                                            .optionalGroupOptions[
                                                            index
                                                          ].plan
                                                        ),
                                                        _vm.currentPricingPlan
                                                      ),
                                                      false,
                                                      true
                                                    )
                                                  )
                                                )
                                              ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "ml-1 gray-60 fs-3 regular"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        / " +
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      _vm.$l10n.__("mois")
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "flex-level ml-4" },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              ref: "offer",
                                              refInFor: true,
                                              attrs: {
                                                checked:
                                                  _vm.getProductMonthlyAmount(
                                                    _vm.getGroupedProductByCode(
                                                      _vm.optionalGroupOptions[
                                                        index
                                                      ].plan
                                                    ),
                                                    _vm.currentPricingPlan
                                                  ) === 0,
                                                disabled: !_vm.canProductBeToggled(
                                                  _vm.getGroupedProductByCode(
                                                    _vm.optionalGroupOptions[
                                                      index
                                                    ].plan
                                                  ),
                                                  false
                                                )
                                              },
                                              on: {
                                                change: function(e) {
                                                  return _vm.offerProduct(
                                                    _vm.getGroupedProductByCode(
                                                      _vm.optionalGroupOptions[
                                                        index
                                                      ].plan
                                                    ),
                                                    index,
                                                    e
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Offert")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ml-4 flex-level aright"
                                        },
                                        [
                                          _c("el-switch", {
                                            attrs: {
                                              value: !!_vm.getCartItem(
                                                _vm.getGroupedProductByCode(
                                                  _vm.optionalGroupOptions[
                                                    index
                                                  ].plan
                                                ).id
                                              ),
                                              disabled: !_vm.canProductBeToggled(
                                                _vm.getGroupedProductByCode(
                                                  _vm.optionalGroupOptions[
                                                    index
                                                  ].plan
                                                ),
                                                false
                                              )
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.toggleItem(
                                                  _vm.getGroupedProductByCode(
                                                    _vm.optionalGroupOptions[
                                                      index
                                                    ].plan
                                                  )
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.cartHasDiscount
                    ? _c("div", { staticClass: "mt-4" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "my-1 wp-8 flex-level flex-item-right gray-60"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$l10n.__("Sous total hors remises")
                                ) +
                                "\n                        "
                            ),
                            _c("span", { staticClass: "flex-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("numberformat")(
                                    _vm.currentPricingTotal.raw,
                                    true
                                  )
                                )
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "my-1 wp-8 flex-level flex-item-right gray-60"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$l10n.__("Montant total remises")) +
                                "\n                        "
                            ),
                            _c("span", { staticClass: "flex-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("numberformat")(
                                    _vm.currentPricingTotal.discount,
                                    true
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "my-4" }, [
                    _c(
                      "h2",
                      {
                        staticClass:
                          "wp-8 flex-level flex-item-right mt-3 mb-0",
                        class: { "primary-50": _vm.isCurrentPricingMonthly }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm.$l10n.__("Total mensuel")
                              )
                            ) +
                            "\n                        "
                        ),
                        _c("span", { staticClass: "flex-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("numberformat")(
                                _vm.cartTotal.monthly.totalDiscounted,
                                true
                              )
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.cartHasDiscount
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "my-1 wp-8 flex-level flex-item-right gray-60"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$l10n.__("Dont remise mensuelle")) +
                                "\n                        "
                            ),
                            _c("span", { staticClass: "flex-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("numberformat")(
                                    _vm.cartTotal.monthly.discount,
                                    true
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (!_vm.billingAddressTmp.vatIdentificationNumber ||
                      !_vm.hasCountryIntraVat(_vm.billingAddressTmp.country)) &&
                    _vm.currentCountryTaxRate > 0
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "my-1 wp-8 flex-level flex-item-right gray-60"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$l10n.__("TVA")) +
                                " (" +
                                _vm._s(_vm.currentCountryTaxRate * 100) +
                                "%)\n                        "
                            ),
                            _c("span", { staticClass: "flex-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("numberformat")(
                                    _vm.cartTotal.monthly.tax,
                                    true
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (!_vm.billingAddressTmp.vatIdentificationNumber ||
                      !_vm.hasCountryIntraVat(_vm.billingAddressTmp.country)) &&
                    _vm.currentCountryTaxRate > 0
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "my-1 wp-8 flex-level flex-item-right gray-60"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm.$l10n.__("Total TTC mensuel")
                                  )
                                ) +
                                "\n                        "
                            ),
                            _c("span", { staticClass: "flex-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("numberformat")(
                                    _vm.cartTotal.monthly.totalTaxIncluded,
                                    true
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.isCartContext("upsale")
                    ? _c(
                        "div",
                        {
                          staticClass: "my-2 px-1 pr-2 pb-1 default-bkg grey br"
                        },
                        [
                          _c(
                            "h2",
                            {
                              staticClass:
                                "wp-8 flex-level flex-item-right mt-2 pt-1 mb-0 fs-4"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm.$l10n.__("total mensuel souscrit")
                                    )
                                  ) +
                                  "\n                        "
                              ),
                              _c("span", { staticClass: "flex-right" }, [
                                _vm.newItemsOnSubscriptionTotal.monthly
                                  .totalTaxIncluded
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "mr-1 fs-3 bold",
                                        class: [
                                          _vm.newItemsOnSubscriptionTotal
                                            .monthly.totalTaxIncluded > 0
                                            ? "blue"
                                            : "red"
                                        ]
                                      },
                                      [
                                        _vm._v(
                                          "\n                                (" +
                                            _vm._s(
                                              _vm.newItemsOnSubscriptionTotal
                                                .monthly.totalDiscounted > 0
                                                ? "+"
                                                : ""
                                            ) +
                                            _vm._s(
                                              _vm._f("numberformatWithOptions")(
                                                _vm.newItemsOnSubscriptionTotal
                                                  .monthly.totalDiscounted,
                                                { precision: 0 },
                                                true
                                              )
                                            ) +
                                            ")\n                            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm._f("numberformat")(
                                        _vm.customerSubscribedTotal.monthly
                                          .totalDiscounted,
                                        true
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.cartHasDiscount
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "my-1 wp-8 flex-level flex-item-right"
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$l10n.__("Dont remise mensuelle")
                                      ) +
                                      "\n                        "
                                  ),
                                  _c("span", { staticClass: "flex-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("numberformat")(
                                          _vm.customerSubscribedTotal.monthly
                                            .discount,
                                          true
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          (!_vm.billingAddressTmp.vatIdentificationNumber ||
                            !_vm.hasCountryIntraVat(
                              _vm.billingAddressTmp.country
                            )) &&
                          _vm.currentCountryTaxRate > 0
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "my-1 wp-8 flex-level flex-item-right"
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$l10n.__("TVA")) +
                                      " (" +
                                      _vm._s(_vm.currentCountryTaxRate * 100) +
                                      "%)\n                        "
                                  ),
                                  _c("span", { staticClass: "flex-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("numberformat")(
                                          _vm.customerSubscribedTotal.monthly
                                            .tax,
                                          true
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          (!_vm.billingAddressTmp.vatIdentificationNumber ||
                            !_vm.hasCountryIntraVat(
                              _vm.billingAddressTmp.country
                            )) &&
                          _vm.currentCountryTaxRate > 0
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "my-1 wp-8 flex-level flex-item-right"
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm.$l10n.__("Total TTC mensuel")
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                  _c("span", { staticClass: "flex-right" }, [
                                    _vm.newItemsOnSubscriptionTotal.monthly
                                      .totalTaxIncluded
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "mr-1 fs-3 bold",
                                            class: [
                                              _vm.newItemsOnSubscriptionTotal
                                                .monthly.totalTaxIncluded > 0
                                                ? "blue"
                                                : "red"
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              "\n                                (" +
                                                _vm._s(
                                                  _vm
                                                    .newItemsOnSubscriptionTotal
                                                    .monthly.totalTaxIncluded >
                                                    0
                                                    ? "+"
                                                    : ""
                                                ) +
                                                _vm._s(
                                                  _vm._f(
                                                    "numberformatWithOptions"
                                                  )(
                                                    _vm
                                                      .newItemsOnSubscriptionTotal
                                                      .monthly.totalTaxIncluded,
                                                    { precision: 0 },
                                                    true
                                                  )
                                                ) +
                                                ")\n                            "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm._f("numberformat")(
                                            _vm.customerSubscribedTotal.monthly
                                              .totalTaxIncluded,
                                            true
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "my-2 px-1 pr-2" }, [
                    _c(
                      "h2",
                      {
                        staticClass:
                          "wp-8 flex-level flex-item-right mt-3 mb-0",
                        class: { "primary-50": !_vm.isCurrentPricingMonthly }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$l10n.__("Total annuel")) +
                            "\n                        "
                        ),
                        _c("span", { staticClass: "flex-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("numberformat")(
                                _vm.cartTotal.yearly.totalDiscounted,
                                true
                              )
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.cartHasDiscount
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "my-1 wp-8 flex-level flex-item-right gray-60"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$l10n.__("Dont remise annuelle")) +
                                "\n                        "
                            ),
                            _c("span", { staticClass: "flex-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("numberformat")(
                                    _vm.cartTotal.yearly.discount,
                                    true
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (!_vm.billingAddressTmp.vatIdentificationNumber ||
                      !_vm.hasCountryIntraVat(_vm.billingAddressTmp.country)) &&
                    _vm.currentCountryTaxRate > 0
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "my-1 wp-8 flex-level flex-item-right gray-60"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$l10n.__("TVA")) +
                                " (" +
                                _vm._s(_vm.currentCountryTaxRate * 100) +
                                "%)\n                        "
                            ),
                            _c("span", { staticClass: "flex-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("numberformat")(
                                    _vm.cartTotal.yearly.tax,
                                    true
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (!_vm.billingAddressTmp.vatIdentificationNumber ||
                      !_vm.hasCountryIntraVat(_vm.billingAddressTmp.country)) &&
                    _vm.currentCountryTaxRate > 0
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "my-1 wp-8 flex-level flex-item-right gray-60"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm.$l10n.__("total TTC annuel")
                                  )
                                ) +
                                "\n                        "
                            ),
                            _c("span", { staticClass: "flex-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("numberformat")(
                                    _vm.cartTotal.yearly.totalTaxIncluded,
                                    true
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.isCartContext("upsale")
                    ? _c(
                        "div",
                        {
                          staticClass: "my-2 px-1 pr-2 pb-1 default-bkg grey br"
                        },
                        [
                          _c(
                            "h2",
                            {
                              staticClass:
                                "wp-8 flex-level flex-item-right mt-2 pt-1 mb-0 fs-4"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm.$l10n.__("total annuel souscrit")
                                    )
                                  ) +
                                  "\n                        "
                              ),
                              _c("span", { staticClass: "flex-right" }, [
                                _vm.newItemsOnSubscriptionTotal.yearly
                                  .totalTaxIncluded
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "mr-1 fs-3 bold",
                                        class: [
                                          _vm.newItemsOnSubscriptionTotal.yearly
                                            .totalTaxIncluded > 0
                                            ? "blue"
                                            : "red"
                                        ]
                                      },
                                      [
                                        _vm._v(
                                          "\n                                (" +
                                            _vm._s(
                                              _vm.newItemsOnSubscriptionTotal
                                                .yearly.totalDiscounted > 0
                                                ? "+"
                                                : ""
                                            ) +
                                            _vm._s(
                                              _vm._f("numberformatWithOptions")(
                                                _vm.newItemsOnSubscriptionTotal
                                                  .yearly.totalDiscounted,
                                                { precision: 0 },
                                                true
                                              )
                                            ) +
                                            ")\n                            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm._f("numberformat")(
                                        _vm.customerSubscribedTotal.yearly
                                          .totalDiscounted,
                                        true
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.cartHasDiscount
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "my-1 wp-8 flex-level flex-item-right"
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$l10n.__("Dont remise annuelle")
                                      ) +
                                      "\n                        "
                                  ),
                                  _c("span", { staticClass: "flex-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("numberformat")(
                                          _vm.customerSubscribedTotal.yearly
                                            .discount,
                                          true
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          (!_vm.billingAddressTmp.vatIdentificationNumber ||
                            !_vm.hasCountryIntraVat(
                              _vm.billingAddressTmp.country
                            )) &&
                          _vm.currentCountryTaxRate > 0
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "my-1 wp-8 flex-level flex-item-right"
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$l10n.__("TVA")) +
                                      " (" +
                                      _vm._s(_vm.currentCountryTaxRate * 100) +
                                      "%)\n                        "
                                  ),
                                  _c("span", { staticClass: "flex-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("numberformat")(
                                          _vm.customerSubscribedTotal.yearly
                                            .tax,
                                          true
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          (!_vm.billingAddressTmp.vatIdentificationNumber ||
                            !_vm.hasCountryIntraVat(
                              _vm.billingAddressTmp.country
                            )) &&
                          _vm.currentCountryTaxRate > 0
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "my-1 wp-8 flex-level flex-item-right"
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm.$l10n.__("total TTC annuel")
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                  _c("span", { staticClass: "flex-right" }, [
                                    _vm.newItemsOnSubscriptionTotal.yearly
                                      .totalTaxIncluded
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "mr-1 fs-3 bold",
                                            class: [
                                              _vm.newItemsOnSubscriptionTotal
                                                .yearly.totalTaxIncluded > 0
                                                ? "blue"
                                                : "red"
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              "\n                                (" +
                                                _vm._s(
                                                  _vm
                                                    .newItemsOnSubscriptionTotal
                                                    .yearly.totalTaxIncluded > 0
                                                    ? "+"
                                                    : ""
                                                ) +
                                                _vm._s(
                                                  _vm._f(
                                                    "numberformatWithOptions"
                                                  )(
                                                    _vm
                                                      .newItemsOnSubscriptionTotal
                                                      .yearly.totalTaxIncluded,
                                                    { precision: 0 },
                                                    true
                                                  )
                                                ) +
                                                ")\n                            "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm._f("numberformat")(
                                            _vm.customerSubscribedTotal.yearly
                                              .totalTaxIncluded,
                                            true
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "bt-1 pt-3 m-0",
                      attrs: {
                        prop: "paymentMethod",
                        error: _vm.errors.get("paymentMethod")
                      }
                    },
                    [
                      _c("h4", { staticClass: "mt-2 dinlineb" }, [
                        _vm._v(_vm._s(_vm.$l10n.__("Moyen de paiement")))
                      ]),
                      _vm._v(" "),
                      _c("radio-input", {
                        staticClass: "dinlineb fright",
                        attrs: {
                          mode: "edit",
                          "radio-style": "button",
                          value: _vm.cartPaymentMethod,
                          choices: _vm.paymentMethodsOptions,
                          disabled: !_vm.isEditablePaymentMethod
                        },
                        on: { change: _vm.paymentMethodUpdated }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.cartEarlyRenewal
                    ? _c("p", { staticClass: "mt-3 wp-10 flex-row" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm.$l10n.__("Restant à consommer")
                              )
                            ) +
                            "\n                    "
                        ),
                        _c("span", { staticClass: "fs-3 flex-item-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatAmount(
                                -1 *
                                  this.centsToCurrency(
                                    _vm.cartEarlyRenewalDiscount
                                  ),
                                true
                              )
                            )
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAvailablePaymentFacility
                    ? _c(
                        "div",
                        { staticClass: "flex-level mt-3" },
                        [
                          _c("h4", { staticClass: "mt-2 flex" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("Facilité de paiement")))
                          ]),
                          _vm._v(" "),
                          _c("select-input", {
                            staticClass: "flex-right w-3",
                            attrs: {
                              mode: _vm.isEditablePaymentFacility
                                ? "edit"
                                : "view",
                              value: _vm.cartPaymentFacility,
                              placeholder: _vm.$t.__(
                                "sellsyaccountmanager.subscriptionform.SubscriptionSale.select_payment_method"
                              ),
                              options: _vm.paymentFacilities,
                              "label-column": "label",
                              "id-column": "value",
                              disabled: !_vm.isEditablePaymentFacility
                            },
                            on: { input: _vm.setCartPaymentFacility }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isCurrentPricingMonthly
                    ? [
                        _vm._l(_vm.deadlines, function(deadline) {
                          return _c(
                            "p",
                            {
                              key: deadline.key,
                              staticClass:
                                "my-1 mt-3 wp-10 flex-level flex-item-right gray-60"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm._f("dateFormatter")(
                                      deadline.date.unix(),
                                      "NORMAL_DATE",
                                      false
                                    )
                                  ) +
                                  "\n                        "
                              ),
                              _c("span", { staticClass: "fs-3 flex-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatAmount(deadline.amount, true)
                                  )
                                )
                              ])
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.deadlineUnchanged > 0 && _vm.deadlineUnchanged < 12
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "my-1 wp-10 flex-level flex-item-right gray-60"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "%(deadlineUnchanged)s échéances suivantes",
                                        {
                                          deadlineUnchanged:
                                            _vm.deadlineUnchanged
                                        }
                                      )
                                    ) +
                                    "\n                        "
                                ),
                                _c("span", { staticClass: "fs-3 flex-right" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.formatAmount(
                                          _vm.currentPricingTotal
                                            .totalTaxIncluded,
                                          true
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    : [
                        _vm.isPaymentFacilityEnabled
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "my-1 mt-3 wp-10 flex-level flex-item-right"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm.$l10n.__(
                                          "Paiement en %s fois",
                                          _vm.cartPaymentFacility
                                        )
                                      )
                                    ) +
                                    "\n                        "
                                ),
                                _vm.cartNextAmountFacility <
                                _vm.cartFirstAmountFacility
                                  ? _c(
                                      "span",
                                      { staticClass: "fs-3 flex-right" },
                                      [
                                        _vm._v(
                                          "\n                            1 x " +
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm.cartFirstAmountFacility,
                                                true
                                              )
                                            )
                                        ),
                                        _c("br")
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      { staticClass: "fs-3 flex-right" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.cartPaymentFacility) +
                                            " x\n                            " +
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm.cartFirstAmountFacility,
                                                true
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isPaymentFacilityEnabled &&
                        _vm.cartNextAmountFacility < _vm.cartFirstAmountFacility
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "my-1 wp-10 flex-level flex-item-right"
                              },
                              [
                                _c("span", { staticClass: "fs-3 flex-right" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.cartPaymentFacility - 1) +
                                      " x\n                            " +
                                      _vm._s(
                                        _vm.formatAmount(
                                          _vm.cartNextAmountFacility,
                                          true
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isCustomPaymentFacilityEnabled
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "my-1 wp-10 flex-level flex-item-right"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm.$l10n.__(
                                          "Paiement en %s fois",
                                          _vm.cartNbCustomFacilities
                                        )
                                      )
                                    ) +
                                    "\n                        "
                                ),
                                _vm.cartFirstAmountCustomFacility <
                                _vm.cartLastAmountCustomFacility
                                  ? _c(
                                      "span",
                                      { staticClass: "fs-3 flex-right" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.cartNbFirstCustomFacilities
                                            ) +
                                            " x\n                            " +
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm.cartFirstAmountCustomFacility,
                                                true
                                              )
                                            )
                                        ),
                                        _c("br")
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      { staticClass: "fs-3 flex-right" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.cartNbCustomFacilities) +
                                            " x\n                            " +
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm.cartFirstAmountFacility,
                                                true
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isCustomPaymentFacilityEnabled &&
                        _vm.cartFirstAmountCustomFacility <
                          _vm.cartLastAmountCustomFacility
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "my-1 wp-6 flex-level flex-item-right"
                              },
                              [
                                _c("span", { staticClass: "fs-3 flex-right" }, [
                                  _vm._v(
                                    "\n                            1 x " +
                                      _vm._s(
                                        _vm.formatAmount(
                                          _vm.cartLastAmountCustomFacility,
                                          true
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _vm.currentCartUrlForCustomer && _vm.savedCartStatus !== "draft"
                ? _c(
                    "div",
                    { staticClass: "flex-level mt-5" },
                    [
                      _c("h4", { staticClass: "m-0" }, [
                        _vm._v(_vm._s(_vm.$l10n.__("Lien du panier :")))
                      ]),
                      _vm._v(" "),
                      _c("text-input", {
                        staticClass: "flex mx-3",
                        attrs: {
                          mode: "edit",
                          value: _vm.currentCartUrlForCustomer,
                          readonly: true
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-default",
                          attrs: { role: "button" },
                          on: {
                            click: function($event) {
                              return _vm.handleCopyToClipboardWithToast(
                                _vm.currentCartUrlForCustomer
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$l10n.__("Copier")) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("bottom-bar", [
        _c("div", [
          _c(
            "a",
            {
              staticClass: "btn btn-default mr-5",
              attrs: { role: "button", href: _vm.urlToCustomerThirdOverview }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$l10n.__("Retour")) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _vm.isCartLoaded
            ? _c(
                "a",
                {
                  staticClass: "btn btn-danger mr-2",
                  attrs: { role: "button", disabled: !_vm.canCartBeCanceled },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.canCartBeCanceled
                        ? _vm.confirmCartDeletion(_vm.cancelCart)
                        : ""
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("Supprimer le panier")) +
                      "\n            "
                  )
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-right" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-secondary",
              attrs: { role: "button", disabled: !_vm.canCartBeSaved },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.canCartBeSaved
                    ? _vm.submitForm("subscriptionForm", "saveDraft")
                    : ""
                }
              }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    !_vm.isCartLoaded ||
                      (_vm.isCartLoaded && _vm.savedCartStatus == "draft")
                      ? _vm.$l10n.__("Enregistrer en brouillon")
                      : _vm.$l10n.__("Enregistrer et repasser en brouillon")
                  ) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-primary ml-5",
              attrs: { role: "button", disabled: !_vm.canCartBeSaved },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.canCartBeSaved ? _vm.submitForm("subscriptionForm") : ""
                }
              }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.isCartLoaded && _vm.savedCartStatus !== "draft"
                      ? _vm.$l10n.__("Enregistrer et renvoyer au client")
                      : _vm.$l10n.__("Enregistrer et envoyer au client")
                  ) +
                  "\n            "
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }